export enum ReviewBucketsType {
    Default,
    Stars,
}
